import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import Gallery from '../../../../components/presentation/gallery/Gallery'
import Panel from '../../../../components/structure/Panel'

const DocumentsDetailsPanel = ({ documents }) => {
  if (!documents || !documents.length) return false

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">Documentos</Title>
      <Gallery colWidth="20%" thumbHeight="8rem" items={documents} />
    </Panel>
  )
}

export default DocumentsDetailsPanel
